export const formatCents = (cents: number, currency = "eur") => {
  const value = cents / 100;
  return value.toLocaleString("fr-FR", {
    style: "currency",
    currency: currency.toUpperCase(),
    maximumFractionDigits: 0,
  });
};

export const formatCentsByCurrency = (byCcy: Record<string, number>) => {
  const entries = Object.entries(byCcy);
  if (entries.length === 0) return formatCents(0, "eur");
  return entries.map(([ccy, c]) => formatCents(c, ccy)).join(" + ");
};

// Cents → "1 234,56 €". Unknown ISO code (Intl throws) falls back to "12.34 XYZ".
export const formatCurrency = (
  cents: number | null | undefined,
  currency = "eur",
) => {
  if (cents == null) return "—";
  const amount = cents / 100;
  try {
    return amount.toLocaleString("fr-FR", {
      style: "currency",
      currency: currency.toUpperCase(),
    });
  } catch {
    return `${amount.toFixed(2)} ${currency.toUpperCase()}`;
  }
};

// Deal amounts (whole units, not cents): "$1.23K".
export const formatCompactCurrency = (amount: number, currency: string) =>
  amount.toLocaleString("en-US", {
    notation: "compact",
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol",
    minimumSignificantDigits: 3,
  });
